const initialState = {
    hospitalPermissionsApproval:{},
    hospitalListsApproval: [],
    hospitalStatusApproval: [],
    changedHospitalStatusApproval : [],
    addHospitalResponseApproval : [],
    loadingHospitalApproval: false,
    isDisabledApproval: true,
    hospitalBasicInfoApproval : [],
    hospitalDetailsApproval : [],
    accountDetailsApproval : [],
    errorsHospitalApproval: {},
    errorsRegistrationApproval: {},
    errorsOldDataApproval: {},
    errorsTpaApproval: {},
    errorsRmoApproval: {},
    errorsNursingApproval: {},
    hospitalIdApproval :'',
    alertDataApproval:[],
    grievanceDataApproval:[],
    hospitalOldDetailApproval:[],
    hospitalProfileApproval:[],
    registrationDetailsApproval : [],
    tpaStaffsApproval:[],
    rmoStaffsApproval:[],
    ownerStaffApproval:[],
    ownerStaffsApproval:[],
    nursingStaffsApproval:[],
    isCashlessAvailableApproval:"",
    hospitalInsuranceCompaniesApproval:[],
    rohiniDetailApproval:[],
    messageApproval:"",
}

const  hospitalReducerApproval = (state = initialState, action) => {
    switch (action.type) {
        case "GET_HOSPITALLIST_PENDING_APPROVAL":
        case "GET_HOSPITAL_DETAIL_PENDING_APPROVAL":
        case "UPDATE_HOSPITAL_PENDING_APPROVAL":
        case "UPDATE_HOSPITAL_STATUS_PENDING_APPROVAL":
        case "DELETE_HOSPITAL_PENDING_APPROVAL":
        case "GET_HOSPITALLISTBYID_PENDING_APPROVAL":
        case "GET_HOSPITAL_ACCOUNT_DETAIL_PENDING_APPROVAL":
        case "ADD_HOSPITAL_REGISTRATION_DETAILS_PENDING_APPROVAL":
        case "GET_HOSPITAL_REGISTRATION_DETAILS_PENDING_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_PENDING_APPROVAL":
        case "ADD_HOSPITAL_STAFF_PENDING_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_PENDING_APPROVAL":
        case "ADD_UPDATE_ROHINI_DETAILS_PENDING_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_PROFILE_PENDING_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_ALERT_PENDING_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_PENDING_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_PENDING_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_TPA_PENDING_APPROVAL":
        case "DELETE_HOSPITAL_STAFF_PENDING_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: true,
                messageApproval:""
             };
        case "SET_MESSAGE_APPROVAL":
            return { ...state,
                messageApproval:action.payload 
            };
        case "SHOW_HOSPITAL_OTHER_FORMS_PENDING_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: true,
                isDisabledApproval: true,
                addHospitalResponseApproval:[],
                errorsRegistrationApproval:{},
                messageApproval:"",
                hospitalBasicInfoApproval : [],
                hospitalDetailsApproval : [],
                accountDetailsApproval : [],
                errorsHospitalApproval: {},
                errorsOldDataApproval: {},
                errorsTpaApproval: {},
                errorsRmoApproval: {},
                errorsNursingApproval: {},
                hospitalIdApproval :'',
                alertDataApproval:[],
                grievanceDataApproval:[],
                hospitalOldDetailApproval:[],
                hospitalProfileApproval:[],
                registrationDetailsApproval : [],
                tpaStaffsApproval:[],
                rmoStaffsApproval:[],
                ownerStaffApproval:[],
                ownerStaffsApproval:[],
                nursingStaffsApproval:[],
                isCashlessAvailableApproval:"",
                hospitalInsuranceCompaniesApproval:[],
                rohiniDetailApproval:[],
             };
        case "SHOW_HOSPITAL_OTHER_FORMS_FULFILLED_APPROVAL":
            return { 
                ...state, 
                isDisabledApproval: false,
                hospitalIdApproval:action.payload,
                messageApproval:""
             };

        case "GET_HOSPITALLIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                hospitalListsApproval: action.payload,
                hospitalCountApproval: action.count,
                hospitalPermissionsApproval:action.permissions,
            };

        case "ADD_HOSPITAL_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                addHospitalResponseApproval: action.payload,
                isDisabledApproval:false,
                hospitalIdApproval: action.payload?.data?.id,
                messageApproval:action.payload?.message,
            };

        case "UPDATE_HOSPITAL_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                changedHospitalStatusApproval: action.payload,
                messageApproval:action.payload?.message,
            };

        case "GET_HOSPITAL_DETAIL_FULFILLED_APPROVAL":
            const data = action.payload;
            return {
                ...state,
                loadingHospitalApproval: false,
                hospitalDetailsApproval: data,
                accountDetailsApproval:data?.accountDetail,
                alertDataApproval:data?.alert,
                grievanceDataApproval:data?.grievance,
                hospitalOldDetailApproval:data?.oldDetail,
                hospitalProfileApproval:data?.profile,
                registrationDetailsApproval:data?.registrationDetail,
                tpaStaffsApproval:data?.tpaStaffs,
                rmoStaffsApproval:data?.rmoStaff,
                ownerStaffApproval:data?.ownerStaff,
                ownerStaffsApproval: Array.isArray(data?.ownerStaffs) ? data.ownerStaffs : [],
                nursingStaffsApproval:data?.nursingStaff,
                hospitalInsuranceCompaniesApproval:data?.hospitalInsuranceCompanies,
                isCashlessAvailableApproval:data?.is_cashless_facility,
                rohiniDetailApproval:data?.rohiniDetail,
            };

        case "UPDATE_HOSPITAL_STATUS_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                changedHospitalStatusApproval: action.payload,
            };

        case "GET_HOSPITALLISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                hospitalBasicInfoApproval: action.payload
            };

        case "DELETE_HOSPITAL_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                changedHospitalStatusApproval: action.payload
            };

        case "RESET_DELETE_HOSPITALS_STATUS_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                changedHospitalStatusApproval: [],
                errorsHospitalApproval:{}
            };

        case "GET_HOSPITAL_ACCOUNT_DETAIL_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                hospitalBasicInfoApproval: action.payload.data
            };
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsRegistrationApproval:{},
                messageApproval:action.payload?.message,
                hospitalBasicInfoApproval:action.payload?.data,
            };
        case "ADD_HOSPITAL_STAFF_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsHospitalApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsHospitalApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_HOSPITAL_CASHLESS_STATUS_FULFILLED_APPROVAL":
            const hospital = action.payload?.hospital;
            return { 
                ...state,
                loadingHospitalApproval: false,
                errorsHospitalApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                // isCashlessAvailable:hospital?.is_cashless_facility,
                // hospitalInsuranceCompanies:action.payload?.hospital_insurance_companies,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_ROHINI_DETAILS_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsHospitalApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload.message,
            };
        case "ADD_UPDATE_HOSPITAL_PROFILE_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsHospitalApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_ALERT_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsHospitalApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsHospitalApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsOldDataApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_TPA_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsTpaApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_RMO_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsRmoApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_NURSING_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsNursingApproval:{},
                hospitalBasicInfoApproval:action.payload?.data,
                messageApproval:action.payload?.message,
            };
        case "DELETE_HOSPITAL_STAFF_FULFILLED_APPROVAL":
            return { 
                ...state, 
                loadingHospitalApproval: false,
                errorsNursingApproval:{},
                messageApproval:action.payload?.message,
            };

        case "GET_HOSPITALLIST_REJECTED_APPROVAL":
        case "ADD_HOSPITAL_REJECTED_APPROVAL":
        case "GET_HOSPITAL_DETAIL_REJECTED_APPROVAL":
        case "UPDATE_HOSPITAL_REJECTED_APPROVAL":
        case "UPDATE_HOSPITAL_STATUS_REJECTED_APPROVAL":
        case "DELETE_HOSPITAL_REJECTED_APPROVAL":
        case "GET_HOSPITALLISTBYID_REJECTED_APPROVAL":
        case "GET_HOSPITAL_ACCOUNT_DETAIL_REJECTED_APPROVAL":
        case "ADD_HOSPITAL_REGISTRATION_DETAILS_REJECTED_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_FULFILLED_APPROVAL":
        case "ADD_HOSPITAL_STAFF_REJECTED_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_REJECTED_APPROVAL":
        case "ADD_HOSPITAL_CASHLESS_STATUS_REJECTED_APPROVAL":
        case "ADD_UPDATE_ROHINI_DETAILS_REJECTED_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_PROFILE_REJECTED_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_ALERT_REJECTED_APPROVAL":
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_REJECTED_APPROVAL":
        case "DELETE_HOSPITAL_STAFF_REJECTED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                errorsHospitalApproval: action.payload
            };
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_REJECTED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                errorsHospitalApproval: action.payload
            };
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_REJECTED_APPROVAL":
            console.log(action.payload,action.payload)
            return {
                ...state,
                loadingHospitalApproval: false,
                errorsHospitalApproval: action.payload
            };
        case "ADD_UPDATE_HOSPITAL_TPA_REJECTED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                errorsHospitalApproval: action.payload?.data
            };
        case "ADD_UPDATE_HOSPITAL_RMO_REJECTED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                errorsHospitalApproval: action.payload?.data
            };
        case "ADD_UPDATE_HOSPITAL_NURSING_REJECTED_APPROVAL":
            return {
                ...state,
                loadingHospitalApproval: false,
                errorsHospitalApproval: action.payload?.data
            };

            case "RESET_HOSPITAL_STATE_APPROVAL":
                return { 
                    ...state, 
                    addHospitalResponseApproval:[],
                    errorsRegistrationApproval:{},
                    messageApproval:"",
                    hospitalBasicInfoApproval : [],
                    hospitalDetailsApproval : [],
                    accountDetailsApproval : [],
                    errorsHospitalApproval: {},
                    errorsOldDataApproval: {},
                    errorsTpaApproval: {},
                    errorsRmoApproval: {},
                    errorsNursingApproval: {},
                    hospitalIdApproval :'',
                    alertDataApproval:[],
                    grievanceDataApproval:[],
                    hospitalOldDetailApproval:[],
                    hospitalProfileApproval:[],
                    registrationDetailsApproval : [],
                    tpaStaffsApproval:[],
                    rmoStaffsApproval:[],
                    ownerStaffApproval:[],
                    ownerStaffsApproval:[],
                    nursingStaffsApproval:[],
                    isCashlessAvailableApproval:"",
                    hospitalInsuranceCompaniesApproval:[],
                    rohiniDetailApproval:[],
                 };

        default:
            return state;
    }
}

export default hospitalReducerApproval;